export const SELECT_ISSUE_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select what the issue relates to',
  },
};

export const SELECT_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Please select an option',
  },
};
